import { render, staticRenderFns } from "./OctFormRow.vue?vue&type=template&id=044944e8&scoped=true&"
import script from "./OctFormRow.vue?vue&type=script&lang=js&"
export * from "./OctFormRow.vue?vue&type=script&lang=js&"
import style0 from "./OctFormRow.vue?vue&type=style&index=0&id=044944e8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044944e8",
  null
  
)

export default component.exports